module.exports = __webpack_public_path__ + "img/tech-pro-es.10520131.jpg";